// Static test-ids for action options container
export default {
  CONTAINER: 'ACTIONOPTIONS_CONTAINER',
  DROPDOWN_SELECT_CLICK: 'ACTIONOPTIONS_DROPDOWN_SELECT_CLICK',
  DROPDOWN_ARROW_ICON: 'ACTIONOPTIONS_DROPDOWN_ARROW_ICON',
  // Dynamic test-ids generated via utils
};
